// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"MenuTooltip_tooltipContent__1UiPJ","tooltipLink":"MenuTooltip_tooltipLink__1o0tv"};